import { api, apiQueryKey } from '@/shared/api'
import { WorkspaceWithLinkDescriptor } from '@synapex/shared2/entities'
import { CreativePreviewReply } from '@synapex/shared2/gateway-rest-api'
import { useQuery } from '@tanstack/react-query'

export const useCreativePreview = (
    { workspace_id, ...ld }: WorkspaceWithLinkDescriptor,
    {
        enabled,
    }: {
        enabled: boolean
    }
) => {
    return useQuery({
        queryKey: apiQueryKey.creativePreview({ workspace_id, ...ld }),
        queryFn: () =>
            api.get<CreativePreviewReply>(`/creatives/preview`, {
                params: ld,
            }),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled,
    })
}
